import React from 'react';
import { inject, observer } from 'mobx-react';
import H5ThreadDetailImgList from './h5';
import PCThreadDetailImgList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface ThreadDetailImgListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    imageList: any;
    allowDownload?: boolean;
    isVivoBrowserStatus?: any
}


@inject('app', 'site', 'user')
@observer
// 下载APP入口，h5是悬浮在页面顶部，pc是放在页面内容右侧
class ThreadDetailImgList extends React.Component<ThreadDetailImgListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('这是header');
    }

    render() {
        const { site, app, imageList, ...props } = this.props;
        const platform = app?.platform || 'h5';
        
        if (platform === 'pc') {
            return <PCThreadDetailImgList imageList={imageList} {...props} />;
        }
        
        return <H5ThreadDetailImgList imageList={imageList} {...props} />;

    }
}

export default ThreadDetailImgList;